var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWestfieldAppinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M31 7h2m-11 3h22"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15 55 2-5-1.701-5.104a4 4 0 0 1-.165-1.83l.755-5.29a4 4 0 0 0-.079-1.536l-1.427-5.706A1.707 1.707 0 0 1 15.5 28.5l.237-.079a4 4 0 0 1 2.526-.001l1.746.58"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M38 48v.597a4 4 0 0 1-.877 2.499l-2.025 2.532a8 8 0 0 1-2.67 2.158l-2.426 1.213A6.74 6.74 0 0 0 26.995 60"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37 38-7.168-15.233a2 2 0 0 1 .915-2.64l.464-.233a2 2 0 0 1 2.683.895L40 33"
}), /*#__PURE__*/React.createElement("path", {
  d: "m44 32-3.106-6.211a2 2 0 0 0-2.683-.895L36 26"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49 33-3.106-6.211a2 2 0 0 0-2.683-.895L41 27"
}), /*#__PURE__*/React.createElement("path", {
  d: "m59 49-1.328-1.992a4 4 0 0 1-.672-2.22v-3.844a4 4 0 0 0-.422-1.789L54 34l-3.106-6.211a2 2 0 0 0-2.683-.895L46 28m1 27-1.874-3.748a1 1 0 0 0-.365-.401l-6.01-3.757a8 8 0 0 1-2.754-2.899l-3.264-5.876a2 2 0 0 1 .334-2.386L35 34"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M37.077 46h-15.23C20.826 46 20 45.145 20 44.09V5.91C20 4.854 20.827 4 21.846 4h20.308C43.174 4 44 4.855 44 5.91v18.094"
}))));
export default SvgWestfieldAppinline;